import 'must';
import {AbstractNegotiationCloser} from "@/modules/diplomacy/services/AbstractNegotiationCloser";
import {inject, injectable} from "inversify";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {Negotiation} from "@/modules/diplomacy/entity";
import {PlayerContractNegotiation} from "@/modules/team/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {EventEmitter} from "@/modules/base/events";
import {BeforePlayerContractExtendedEvent} from "@/modules/team/events/BeforePlayerContractExtendedEvent";
import {AfterPlayerContractExtendedEvent} from "@/modules/team/events/AfterPlayerContractExtendedEvent";

@injectable()
export class PlayerContractNegotiationCloser extends AbstractNegotiationCloser implements NegotiationCloserInterface {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(EventEmitter) private em: EventEmitter,
  ) {
    super();
  }

  async shouldRun(negotiation: Negotiation) {
    return negotiation instanceof PlayerContractNegotiation;
  }

  async close(negotiation: PlayerContractNegotiation): Promise<void> {
    negotiation.years.must.be.above(negotiation.target.contractYears);
    negotiation.years.must.be.most(this.configRepository.get('players.contract.maxYears'));

    await this.em.emitAsync(
      new BeforePlayerContractExtendedEvent(negotiation.target, negotiation.years, negotiation.once)
    );

    negotiation.target.contractYears = negotiation.negotiationCurrentYears;
    negotiation.target.wage = negotiation.monthly;
    await negotiation.target.save();

    await this.em.emitAsync(
      new AfterPlayerContractExtendedEvent(negotiation.target, negotiation.years, negotiation.once)
    );

    await super.close(negotiation);
  }
}